export type IAPIBOPISInventory = IAPIBOPISInventoryMetadata &
    IAPIBOPISInventoryResponseResults &
    IAPIBOPISConfig;

export interface IAPIBOPISInventoryResponseResults {
    doors: IAPIBOPISInventoryDoorsMap;
}

interface IAPIBOPISInventoryDoorsMap {
    [key: string]: IBOPISDoorData;
}

export interface IAPIBOPISInventoryMetadata {
    latitude: string;
    longitude: string;
    driving_directions: string;
    door_count: number;
    country_code: string;
    bopis_store_number: string;
}

export interface IBOPISDoorData {
    door_inventory: IDoorInventoryContent;
    info: IBOPISStore;
    omni_door_status: IDoorStatus;
    store_hours: IStoreHoursList;
}
export interface IAPIBOPISConfig {
    config: IShipMethods;
}

export interface IBOPISStore {
    DISTANCE: string;
    TIME_ZONE: string;
    DOOR_ID: string;
    CITY: string;
    COUNTRY: string;
    DOORNAME: string;
    PHONE1: string;
    OMNI_DOOR_STATUS: string;
    LATITUDE: string;
    ADDRESS2: string;
    ADDRESS: string;
    ZIP_OR_POSTAL: string;
    SUB_HEADING: string;
    TIME_ZONE_UTC_OFFSET: string;
    EVENT_FEATURES: string;
    EVENT_TIMES: string;
    LONGITUDE: string;
    JDA_STORE_NUMBER: string;
    STATE_OR_PROVINCE: string;
    HAS_CURBSIDE_PICKUP: number;
}

export interface IDoorStatus {
    bopis: string;
    courier_delivery: string;
}

export interface IDoorInventoryContent {
    skus_onhand: { [key: string]: ISkusOnhand };
    cart_skus_onhand: { [key: string]: ISkusOnhand };
}

export interface ISkusOnhand {
    available_qty: string;
    is_available: number;
}

export interface StoreHours {
    [doorId: string]: IStoreHoursList;
}

export interface IStoreHoursList {
    opening_hours: IOpeningHours;
}

export interface IOpeningHours {
    raw: { [key: string]: IRaw };
    rendered: { [key: string]: string };
}

export interface IRaw {
    close: string;
    open: string;
}

export enum DOOR_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
export interface IShipMethods {
    shipmethods: IShipMethod[];
}

export interface IShipMethod {
    label: string;
    price: string;
    value: number;
}
